import React from 'react';
import { ChevronRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'relative inline-flex items-center justify-center font-bold rounded-full transition-all duration-300 ease-out overflow-hidden group';
  const variants = {
    primary: 'bg-warm-accent text-white hover:bg-[#E89B3E] shadow-[0_8px_20px_rgba(246,173,85,0.3)] hover:shadow-[0_12px_25px_rgba(246,173,85,0.4)] hover:-translate-y-1',
    secondary: 'bg-white text-deep-blue border-2 border-deep-blue/10 hover:border-warm-accent hover:text-warm-accent shadow-sm hover:shadow-md'
  };
  const sizes = 'py-4 px-8 text-lg md:text-xl';
  const width = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${sizes} ${width} ${className}`} {...props} data-id="element-135">
      <span className="relative z-10 flex items-center gap-2" data-id="element-136">
        {children}
        {variant === 'primary' && <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-137" />}
      </span>
      {variant === 'primary' && <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform duration-300 ease-out rounded-full" data-id="element-138" />}
    </button>;
}